// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
export const AggregatorInterface_ABI = [
  {
    type: 'function',
    name: 'getAnswer',
    inputs: [
      {
        name: 'roundId',
        type: 'uint256',
        internalType: 'uint256',
      },
    ],
    outputs: [
      {
        name: 'value',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'timestamp',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getLatestAnswer',
    inputs: [],
    outputs: [
      {
        name: 'value',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'timestamp',
        type: 'uint64',
        internalType: 'uint64',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'getRoundData',
    inputs: [
      {
        name: '_roundId',
        type: 'uint80',
        internalType: 'uint80',
      },
    ],
    outputs: [
      {
        name: 'roundId',
        type: 'uint80',
        internalType: 'uint80',
      },
      {
        name: 'answer',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'startedAt',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'updatedAt',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'answeredInRound',
        type: 'uint80',
        internalType: 'uint80',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'latestRoundData',
    inputs: [],
    outputs: [
      {
        name: 'roundId',
        type: 'uint80',
        internalType: 'uint80',
      },
      {
        name: 'answer',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'startedAt',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'updatedAt',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'answeredInRound',
        type: 'uint80',
        internalType: 'uint80',
      },
    ],
    stateMutability: 'view',
  },
] as const;
